import React, { useState } from "react";
import { connect } from "react-redux";
import { RootState } from "../../models/RootState";
import { addExchangeBet, getEventInfo, getFancyMarkets } from "../../store";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material";
import moment from "moment";
import Betslip from "../BetSlip/BetSlip";
import { BsData } from "../../models/BsData";
import MarketOddBtn from "../OddButton/MarketOddBtn";
import { EventData, FancyMarkets, Runners } from "../../models/EventData";
import "./FancyTable.scss";
import { disabledStatus } from "../../constants/common-utlits";

type StoreProps = {
  bets: BsData[];
  addExchangeBet: (data) => void;
  eventData: EventData;
  fancyMarkets: FancyMarkets[];
};

const FancyTable: React.FC<StoreProps> = (props) => {
  const { eventData, bets, addExchangeBet, fancyMarkets } = props;
  const disabledStatus = ["suspended", "suspended-manually", "ball_running"];

  const [selectedRow, setSelectedRow] = useState<string>("");

  const getFancyMarketsByGroup = (fancyMarkets: FancyMarkets[]) => {
    return fancyMarkets.sort((a, b) => {
      const aDesc = a.marketName;
      const bDesc = b.marketName;
      if (aDesc > bDesc) return 1;
      else if (aDesc < bDesc) return -1;
      return 0;
    });
  };
  return (
    <>
      <div className="fm-table-ctn fancy-ctn">
        <div className="fm-table-content table-ctn">
          <TableContainer component={Paper}>
            <Table className="fm-table">
              <TableHead>
                <TableRow>
                  <TableCell colSpan={3}>
                    <div className="market-name-cell-head-ctn">
                      <span>Fancy</span>
                      <div className="limit">
                        Min :
                        {fancyMarkets[0]?.limits?.minBetValue
                          ? " " + fancyMarkets[0]?.limits?.minBetValue
                          : "N/A"}
                        {"   "}
                        {"  "}
                        <span></span>
                        Max :
                        {fancyMarkets[0]?.limits?.maxBetValue
                          ? fancyMarkets[0]?.limits?.maxBetValue
                          : "N/A"}
                      </div>{" "}
                    </div>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <FancyHeaderRow groupName={"Session markets"} />
                {fancyMarkets ? (
                  <>
                    {fancyMarkets.map((fm, idx) => (
                      <>
                        {!fm.marketName
                          .toLowerCase()
                          .split(" ")
                          .includes("bhav") ? (
                          <>
                            <div className="section-divider"></div>
                            <FancyMarketRow
                              fanyMarket={fm}
                              // disabledStatus={getEventInfo.fan}
                              bets={bets}
                              addExchangeBet={addExchangeBet}
                              eventData={eventData}
                              // marketName={market.marketName}
                              selectedRow={selectedRow}
                              setSelectedRow={setSelectedRow}
                              min={fm?.limits?.minBetValue}
                              max={fm?.limits?.maxBetValue}
                            />
                          </>
                        ) : null}
                      </>
                    ))}
                  </>
                ) : null}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </>
  );
};

type FancyHeaderRowProps = {
  groupName: string;
};

const FancyHeaderRow: React.FC<FancyHeaderRowProps> = (props) => {
  const { groupName } = props;

  const tableFields = [
    {
      key: "groupName",
      Label: groupName,
      className: "market-name-cell-head",
      align: "left",
    },
    {
      key: "odds-no",
      Label: "No",
      className: "odds-cell-head",
      align: "center",
    },
    {
      key: "odds-yes",
      Label: "Yes",
      className: "odds-cell-head odds-yes-cell",
      align: "center",
    },
  ];

  return (
    <TableRow className="header-row">
      {tableFields.map((tF, index) => (
        <TableCell
          key={tF.key + index}
          align={tF.align === "left" ? "left" : "center"}
          className={tF.className}
        >
          {tF.key === "odds-no" || "odds-yes" ? (
            <div className={tF.key.toLowerCase() + "-cell"}>{tF.Label}</div>
          ) : (
            groupName
          )}
        </TableCell>
      ))}
    </TableRow>
  );
};

type FancyMarketRowProps = {
  fanyMarket: FancyMarkets;
  // disabledStatus: string[];
  bets: BsData[];
  addExchangeBet: (data) => void;
  eventData: EventData;
  // marketName: string;
  selectedRow: string;
  setSelectedRow: (data) => void;
  min: number;
  max: number;
};

const FancyMarketRow: React.FC<FancyMarketRowProps> = (props) => {
  const {
    fanyMarket,
    // runner,
    addExchangeBet,
    // disabledStatus,
    eventData,
    bets,
    selectedRow,
    setSelectedRow,
    min,
    max,
  } = props;

  return (
    <>
      <TableRow className="fm-row">
        <TableCell className="market-name-cell">
          <div className="market">{fanyMarket.marketName}</div>
        </TableCell>

        <TableCell
          className="odds-cell"
          key={("row-" + fanyMarket.marketId, +"cell-3")}
          align="right"
        >
          <div className="odds-block">
            <MarketOddBtn
              mainValue={
                fanyMarket.noValue ? Number(fanyMarket.noValue).toFixed() : 0
              }
              subValue={fanyMarket.noRate ? fanyMarket.noRate : 0}
              showSubValueinKformat={true}
              oddType="lay-odd"
              valueType="fancyMarketOdds"
              disable={
                disabledStatus.includes(eventData.status.toLowerCase()) ||
                disabledStatus.includes(fanyMarket.status.toLowerCase())
              }
              onClick={() => {
                setSelectedRow(fanyMarket.marketName + fanyMarket.marketName);
                addExchangeBet({
                  eventId: eventData.eventId,
                  eventName: eventData.eventName,
                  marketId: fanyMarket.marketId,
                  marketType: "FANCY",
                  marketName: fanyMarket.marketName,
                  oddValue: fanyMarket.noRate,
                  sessionOutcome: fanyMarket.noValue,
                  betType: "LAY",
                  stakeAmount: 0,
                  runnerId: fanyMarket.marketId,
                  runnerName: fanyMarket.marketName,
                  competitionId: eventData.competitionId,
                  sportId: eventData.sportId,
                  maxLimit: max,
                  minLimit: min,
                });
              }}
            />
          </div>
        </TableCell>
        <TableCell className="odds-cell">
          <div className="odds-block">
            <MarketOddBtn
              mainValue={Number(fanyMarket.yesValue).toFixed()}
              mainValueClass="runs"
              subValue={fanyMarket.yesRate}
              subValueClass="odds"
              oddType="back-odd"
              valueType="fancyMarketOdds"
              // disable={
              //   moment(eventData.openDate).diff(moment(), "minutes") >
              //   60 * 24 * 2
              // }
              disable={
                disabledStatus.includes(eventData.status.toLowerCase()) ||
                disabledStatus.includes(fanyMarket.status.toLowerCase())
              }
              onClick={() => {
                setSelectedRow(fanyMarket.marketName + fanyMarket.marketName);
                addExchangeBet({
                  eventId: eventData.eventId,
                  eventName: eventData.eventName,
                  marketId: fanyMarket.marketId,
                  marketType: "FANCY",
                  marketName: fanyMarket.marketName,
                  oddValue: fanyMarket.yesRate,
                  sessionOutcome: fanyMarket.yesValue,
                  betType: "BACK",
                  stakeAmount: 0,
                  runnerId: fanyMarket.marketId,
                  runnerName: fanyMarket.marketName,
                  competitionId: eventData.competitionId,
                  sportId: eventData.sportId,
                  maxLimit: max,
                  minLimit: min,
                });
              }}
            />
          </div>
        </TableCell>
      </TableRow>

      {bets.length > 0 &&
      selectedRow === fanyMarket.marketName + fanyMarket.marketName ? (
        <TableRow className="mob-view fm-row">
          <TableCell colSpan={3} className="betslip-mob" align="center">
            <Betslip page={"market"} />{" "}
          </TableCell>
        </TableRow>
      ) : null}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    bets: state.betslip.bets,
    openBets: state.betslip.openBets,
    eventData: state.sportsBook.eventInfo,
    fancyMarkets: getFancyMarkets(state.sportsBook.eventInfo),
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    addExchangeBet: (data: BsData) => dispatch(addExchangeBet(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FancyTable);
